export default Object.freeze({
    en: 'en-US',
    fr: 'fr-FR',
    'fr-ca': 'fr-CA',
});
